import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonVariant, Card, Carousel, CarouselVariant, Group, GroupGutter, Heading, HeadingSize, IconName, IconSize, SliderNavColor, SliderNavVariant, Text, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { getPictureSrcset } from '../../util/ImageUtil';
import { StoreInfoTag } from './StoreInfoTag';
import { StoreAddress } from './StoreAddress';
import { StoreActualInfoTag } from './StoreActualInfoTag';
import { SLIDE_SPACING } from '../../constants/SliderConstants';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_TABLET_SMALL, MAX_SCREEN_WIDTH_MOBILE, MIN_SCREEN_WIDTH_MOBILE, } from '../../constants/ScreenWidthConstants';
import { Box, Stack } from '@yonderland/andes-react';
export const OpenedStores = ({ openedStores, copy }) => {
    const { root, imageCdnPrefix } = useAemConfig();
    if (!openedStores || openedStores.length === 0) {
        return null;
    }
    const carouselProps = {
        variant: CarouselVariant.STORES,
        arrowsConfig: {
            variant: SliderNavVariant.CIRCLE,
            color: SliderNavColor.BASE,
            iconSize: IconSize.MINOR,
        },
        configurationOverrides: {
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            shouldSwiperUpdate: true,
            breakpoints: {
                [MIN_SCREEN_WIDTH_MOBILE]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 1 ? 1.1 : 1,
                },
                [MAX_SCREEN_WIDTH_MOBILE]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 1 ? 1.5 : 1,
                },
                [MIN_SCREEN_WIDTH_TABLET_SMALL]: {
                    spaceBetween: SLIDE_SPACING.MOBILE,
                    slidesPerView: openedStores.length > 2 ? 2.5 : 2,
                },
                [MIN_SCREEN_WIDTH_TABLET]: {
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                    slidesPerView: openedStores.length > 3 ? 3.2 : 3,
                },
                1100: {
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                    slidesPerView: openedStores.length > 4 ? 4.2 : 4,
                },
            },
        },
    };
    const handleClick = (store) => () => (window.location.href = `${root}${store.relativeStorePagePath}.html`);
    return (_jsx(Box, { paddingBlock: { base: '3', lg: '5' }, children: _jsxs(Stack, { direction: "col", gap: "6", children: [_jsx(Heading, { size: HeadingSize.XL, children: copy.title }), _jsx(Carousel, Object.assign({}, carouselProps, { children: openedStores.map(store => (_jsx("div", { style: { height: 'auto' }, children: _jsxs(Card, { onClick: handleClick(store), fullWidth: true, children: [store.image && (_jsx(Card.Media, { src: store.image.imagePath, srcset: getPictureSrcset(store.image, imageCdnPrefix), alt: store.storeName, isPicture: true })), _jsx(Card.Header, { title: store.storeName }), _jsx(Card.Body, { children: _jsxs(Group, { column: true, gutter: GroupGutter.MEDIUM, children: [_jsx(StoreActualInfoTag, { scheduleEntries: store.scheduleEntries }), _jsx(StoreInfoTag, { icon: IconName.MAP_MARKER, children: _jsx(Text, { inline: true, children: _jsx(StoreAddress, { address: store.address }) }) })] }) }), _jsx(Card.Footer, { children: _jsx(Button, { text: copy.button, variant: ButtonVariant.OUTLINED, fill: true }) })] }) }, store.code))) }))] }) }));
};
